import { render, staticRenderFns } from "./OnholdAlert.vue?vue&type=template&id=29dd9d6c&"
import script from "./OnholdAlert.vue?vue&type=script&lang=js&"
export * from "./OnholdAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports